module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_a_blanco-997084f3a303ac75b6f79ca87f819df5.svg";